import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="bg-ink py-20 text-cream sm:py-28" data-id="element-173" data-mp="fwvs5lw74mbo">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-174" data-mp="1wkzqef8mzoe">
        <div className="mx-auto max-w-3xl text-center" data-id="element-175" data-mp="1y5qru2cg0hi">
          <h2 className="font-serif text-4xl font-bold leading-tight sm:text-5xl" data-id="element-176" data-mp="6umh8ux0mqxr">
            You <em className="text-gold" data-id="element-177" data-mp="ukgsj81os7fw">want</em> a home that looks beautiful and up-to-date.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-cream/75" data-id="element-178" data-mp="ymtvxpsynt9i">
            But every change seems to turn into construction, dust, stress, and huge expenses.
          </p>
        </div>

        <div className="mx-auto mt-12 max-w-3xl" data-id="element-179" data-mp="ptql7p9p9uik">
          <ul className="divide-y divide-cream/10 border-y border-cream/10" data-id="element-180" data-mp="psfkxzfgr4w7">
            {painPoints.map(p => <li key={p} className="flex gap-5 py-5" data-id="element-181" data-mp="1di03ih7pg04y">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-gold/60 text-gold" data-id="element-182" data-mp="1ibcqyo0ne0w4">
                  <XIcon className="h-3.5 w-3.5" aria-hidden data-id="element-183" data-mp="26xbji0ut75k0" />
                </span>
                <p className="text-[17px] leading-relaxed text-cream/90" data-id="element-184" data-mp="22znn0tdgx4q0">{p}</p>
              </li>)}
          </ul>
          <p className="mt-8 text-center font-serif text-xl italic leading-relaxed text-gold-soft" data-id="element-185" data-mp="2byhgiavi5ezc">
            Before you tear something out or replace it completely, it's worth knowing what alternatives are available.
          </p>
        </div>
      </div>
    </section>;
}